import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MASKS, NgBrazilValidators } from 'ng-brazil';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LoginService } from 'src/app/services/login.service';

import { Router, ActivatedRoute } from '@angular/router';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { Login } from 'src/app/models/login';
import { RegisterService } from 'src/app/services/register.service';
import { AssignorLead, GestorCadastro } from 'src/app/models/gestor-cadastro';
import { CedenteGestorCadastro } from 'src/app/models/cedentegestor-cadastro';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { CedenteService } from 'src/app/services/cedente.service';

@Component({
  selector: 'app-register-gestor-confirm',
  templateUrl: './register-gestor-confirm.component.html',
  styleUrls: ['./register-gestor-confirm.component.css']
})
export class RegisterGestorConfirmComponent implements OnInit {

  public MASKS = MASKS;

  private gestorCadastro: GestorCadastro;
  private cedenteGestorCadastro: CedenteGestorCadastro;

  loginFormGroup: FormGroup;
  tries = 4;
  error = false;
  blocked = false;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthenticationService,
    private loginService: LoginService,
    private assignorService: CedenteService,
    private alertService: NewAlertService,
    private router: Router,
    private route: ActivatedRoute,
    private registerService: RegisterService) { }

  ngOnInit() {

    this.registerService.currentCadastro.subscribe(
      response => {
        this.cedenteGestorCadastro = response;
        if (this.cedenteGestorCadastro === null) {
          this.router.navigate(['']);
        }
        this.gestorCadastro = this.cedenteGestorCadastro.gestorCadastro;

        this.loginFormGroup = this.formBuilder.group({
          documento: new FormControl('', [
            Validators.required,
            NgBrazilValidators.cpf
          ]),
          password: new FormControl('', [
            Validators.required
          ]),
          nome: new FormControl(this.gestorCadastro.nome, [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(100)
          ]),
          cpf: new FormControl(this.gestorCadastro.cpf, [
            Validators.required,
            NgBrazilValidators.cpf
          ]),
          telefoneNumero: new FormControl(this.gestorCadastro.telefoneNumero, [
            Validators.required,
            NgBrazilValidators.telefone
          ]),
          dataNascimento: new FormControl(this.gestorCadastro.dataNascimento, [
            Validators.required,
            GenericValidator.isAdult
          ])
        });
      }
    );

  }

  ngAfterViewInit() {
    this.assignorService.registerAssignorLead(
      new AssignorLead(
        this.gestorCadastro.companyName,
        this.gestorCadastro.numberOfEmployees,
        this.gestorCadastro.nome,
        this.gestorCadastro.cpf,
        parseInt(this.gestorCadastro.telefoneNumero),
        this.gestorCadastro.dataNascimento,
        this.gestorCadastro.email,
        this.gestorCadastro.emailConfirmacao
      )
    ).subscribe();
  }

  get form() {
    return this.loginFormGroup.controls;
  }

  onSubmit(login: any) {
    if (this.loginFormGroup.valid) {

      this.gestorCadastro.cpf = this.gestorCadastro.cpf.replace(/\D+/g, '').replace(' ', '');
      this.gestorCadastro.telefoneNumero = this.gestorCadastro.telefoneNumero.replace(/\D+/g, '').replace(' ', '');
      this.gestorCadastro.senha = this.loginFormGroup.controls.password.value;

      this.authService.loginRegistered(login.documento.replace(/\D+/g, '').replace(' ', ''), login.password).subscribe(
        response => {
          if (response.status === ApiError.UsuarioBloqueioTemporario) {
            this.blocked = true;
          }

          if (!response.result.authenticated) {
            this.tries--;
            this.error = true;

            if (this.tries === 0) {
              this.blocked = true;
            }

          } else {
            if (response.result.email) {
              this.gestorCadastro.emailConfirmacao = response.result.email;
              this.gestorCadastro.email = response.result.email;
              this.gestorCadastro.senhaConfirmacao = this.gestorCadastro.senha;
              this.cedenteGestorCadastro.gestorCadastro = this.gestorCadastro;
              this.registerService.changeCedenteGestorCadastro(this.cedenteGestorCadastro);
              this.router.navigateByUrl('register/cedente');
            } else {
              this.gestorCadastro.senha = '';
              this.cedenteGestorCadastro.gestorCadastro = this.gestorCadastro;
              this.registerService.changeCedenteGestorCadastro(this.cedenteGestorCadastro);
              this.router.navigateByUrl('register/gestor-account');
            }
          }
        },
        () => this.alertService.error('Não foi possível realizar o login, tente novamente mais tarde', false)
      );
    }
  }

}
